import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Chat } from '../Chat'

@InputType()
export class MergeChatArgs extends ActionArgs {
  @Field(() => String)
  sourceChatId: string

  @Field(() => String)
  targetChatId: string
}

export interface IMergeChat extends IAction<Chat, MergeChatArgs> {}
